(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    

$('.collection-product').slick({
  slidesToShow: 6,
  slidesToScroll: 6,
  arrows: false,
  dots: true,
  infinite: false,
  responsive: [
	{
      breakpoint: 1680,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: false,
      }
    }
  ]
});

$('.collection-banners-wrap').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
		dots: false,
      }
    }
  ]
});

<!-- if( $('#Collection .collection-product ul.slick-dots').css('display') == 'block'){ -->
<!-- 	$('#Collection .collection-product ul.slick-dots').removeAttr("style"); -->
<!--     $('#Collection .collection-product ul.slick-dots').css('display','flex'); -->
<!-- } -->
   

      
$('.collection-banners-wrap').on('afterChange', function(slick, currentSlide){
  console.log(currentSlide);
  var current = currentSlide.currentSlide + 1;
  var string = current + '';
  if (current < 10) {
  	string = '0' + current;
  }
  $(this).parent().find('.collection-banners-current').text(string);
});
             


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	$('.site-footer-title-parent').click(function() {
		$(this).toggleClass('is-opened');
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	$('.js-mobile-nav').click(function() {
      $('.site-header__mobile-nav').toggleClass('is-opened');
      if (!$('.site-header__mobile-nav').hasClass('is-opened')) {
        $('.mobile-nav').find('.is-opened').removeClass('is-opened');
	  }
    });
	$('.js-submenu').click(function() {
      $(this).toggleClass('is-opened');
    });
	$('.mobile-nav__return-btn').click(function(event) {
	  event.stopPropagation();
      var level = $(this).data('level');
      $(this).parents('.mobile-nav__item[data-level="'+ level +'"]').find('.js-submenu').removeClass('is-opened');
    });
    $('.main-search-input').focus(function(){
		$('.main-search-wrap').addClass('is-opened');
    }).focusout(function(){
        $('.main-search-wrap').removeClass('is-opened');
    });

  } catch(e) { console.error(e); }
})();
})();
